import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  /** Preset shape or free-form via width/height. */
  variant?: 'text' | 'title' | 'block' | 'circle';
  width?: string;
  height?: string;
  className?: string;
}

export function Skeleton({ variant = 'text', width, height, className }: SkeletonProps) {
  const style: React.CSSProperties = {};
  if (width) style.width = width;
  if (height) style.height = height;
  return (
    <span
      className={`skeleton skeleton--${variant}${className ? ` ${className}` : ''}`}
      style={style}
      aria-hidden="true"
    />
  );
}

/** Skeleton table body mirroring the My Reports 5-column table. */
export function MyReportsTableSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="skeleton-table" aria-hidden="true">
      {Array.from({ length: rows }).map((_, i) => (
        <div className="skeleton-table__row" key={i}>
          <Skeleton variant="text" width="30%" />
          <Skeleton variant="text" width="12%" />
          <Skeleton variant="text" width="18%" />
          <Skeleton variant="text" width="15%" />
          <Skeleton variant="text" width="10%" />
        </div>
      ))}
    </div>
  );
}

/** Skeleton for the Report Details page body (summary band + sections). */
export function ReportDetailsSkeleton() {
  return (
    <div className="skeleton-details" aria-hidden="true">
      <Skeleton variant="title" width="40%" />
      <div className="skeleton-details__summary">
        <Skeleton variant="block" height="90px" />
        <Skeleton variant="block" height="90px" />
        <Skeleton variant="block" height="90px" />
      </div>
      <Skeleton variant="block" height="120px" />
      <Skeleton variant="block" height="120px" />
    </div>
  );
}
